import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";

export default function ProductCard({product}){
    const { addItem } = useCart();
    const handleAdd = _=> addItem(product, 1);

    return <div className="col-md-4 mb-4">
        <div className="card h-100 shadow-sm">
            <img
                src={product.img}
                className="card-img-top"
                alt="product.name"
                style={{height: "200px", objectFit: "cover"}}
            ></img>
            <div className="card-body d-flex flex-column">
                <h5 className="card-title">{product.name}</h5>
                <p className="card-text text-muted mb-2">${product.price.toFixed(2)}</p>
                <div className="mt-auto d-flex justify-content-between">
                    <Link 
                        className="btn btn-outine-primary btn-sm"
                        to={`product/${product.id}`}>Details</Link>
                    <button
                        className="btn btn-primary btn-sm"
                        onClick={handleAdd}
                    >Add to Cart</button>
                </div>
            </div>
        </div>
    </div>;
}